import { Box, Text, Button, Flex, Heading, List, ListItem, ListIcon, Badge } from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import Reveal, { LiveBackground } from "./motion";
import RosaPreviewCard from "./RosaPreviewCard";
import { HomeContent } from "../data/homeContent";

type ComingSoonProps = { rosa: HomeContent["rosa"] };

const ComingSoon = ({ rosa }: ComingSoonProps) => (
  <Box as="section" id="rosa" position="relative" bg="rosa.50" py={{ base: 20, md: 28 }} overflow="hidden">
    <LiveBackground variant="panel" tone="rosa" />
    <Flex
      position="relative"
      zIndex={1}
      maxW="1400px"
      mx="auto"
      px={{ base: 5, md: 8 }}
      direction={{ base: "column", lg: "row" }}
      align="center"
      gap={{ base: 12, lg: 20 }}
    >
      <Reveal flex="1">
        <Badge
          colorScheme="purple"
          bg="rosa.100"
          color="rosa.700"
          fontWeight="bold"
          px={3}
          py={1}
          borderRadius="full"
          mb={5}
        >
          Hamarosan
        </Badge>

        <Heading as="h2" fontFamily="heading" fontSize={{ base: "3xl", md: "4xl" }} mb={5}>
          <Text as="span" fontFamily="'Lato', sans-serif" fontWeight="800" color="rosa.600">
            Rosa
          </Text>
          : ügyfélszolgálati és ticketkezelő rendszer
        </Heading>

        <Text color="slate.700" fontSize={{ base: "sm", md: "md" }} mb={6} lineHeight="1.8">
          {rosa.body}
        </Text>

        <List spacing={3} mb={6}>
          {rosa.bullets.map((b) => (
            <ListItem key={b} display="flex" alignItems="flex-start" fontSize="sm" color="ink.900">
              <ListIcon as={CheckCircleIcon} color="rosa.600" mt={1} />
              {b}
            </ListItem>
          ))}
        </List>

        <Text color="slate.500" fontSize="sm" mb={8}>
          {rosa.fit}
        </Text>

        <Button
          size="lg"
          bg="rosa.600"
          color="white"
          fontWeight="bold"
          as="a"
          href={`mailto:info@millerproductions.hu?subject=${encodeURIComponent(rosa.mailSubject)}`}
          _hover={{ bg: "rosa.700", transform: "translateY(-2px)" }}
          transition="all 0.2s ease"
        >
          {rosa.cta}
        </Button>
      </Reveal>

      <Reveal flex="1.15" delay={0.15} w="100%">
        <RosaPreviewCard />
      </Reveal>
    </Flex>
  </Box>
);

export default ComingSoon;
